<template>
  <div class="wrapper">
    <h2 class="level">{{ "0" + (index + 1) }}</h2>
    <div class="title">
      <div
        class="b-skeleton b-skeleton-text b-skeleton-animate-wave"
        style="width: 100%; height: 20px;"
      ></div>
    </div>
    <div class="details">
      <div class="categories">
        <div
          class="b-skeleton b-skeleton-button b-skeleton-animate-wave "
          style="width:120px; height: 160px;"
        ></div>
      </div>
      <span class="read"
        ><div
          class="b-skeleton b-skeleton-text b-skeleton-animate-wave"
          style="width: 90px;"
        ></div
      ></span>
    </div>
    <div class="profile-badge">
      <div
        class="b-skeleton b-skeleton-avatar b-skeleton-animate-wave"
        style="width: 30px; height: 30px;"
      ></div>
      <div
        class="b-skeleton b-skeleton-text b-skeleton-animate-wave"
        style="width: 40px;"
      ></div>
      <div
        class="b-skeleton b-skeleton-text b-skeleton-animate-wave"
        style="width: 40px;"
      ></div>
      <div
        class="b-skeleton b-skeleton-button b-skeleton-animate-wave"
        style="width: 10px; height: 20px;"
      ></div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "ArticleCardSkeleton",
  props: ["index"],
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wrapper {
  width: 100%;
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  user-select: none;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  }
  .level {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    color: #a1b1ba;
    margin-bottom: 4px;
    user-select: none;
  }
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #474d52;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .details {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;

    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .ico {
        margin-right: 8px;
      }
    }
    .read {
      display: flex;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
      margin-right: 8px;
      margin-top: 2px;
      margin-left: 60px;
    }
    .ico-bookmark {
      margin-right: 8px;
      cursor: pointer;
      &:hover {
        transform: scale(1.07);
      }
    }
    .ico-share {
      cursor: pointer;
      position: relative;
      svg {
        &:hover {
          transform: scale(1.07);
        }
      }
      &:active {
        transform: none;
      }
      .share-popup {
        position: absolute;
        width: 150px;
        height: 45px;
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        top: 100%;
        left: 80%;
        z-index: 3;
        &:hover {
          transform: none;
        }
      }
    }
  }
  .profile-badge {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    user-select: none;
    grid-column-gap: 8px;
    img {
      height: 32px;
      width: 32px;
      border-radius: 50%;
      object-fit: cover;
    }
    .name {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 26px;
      color: #474d52;
      margin: 0;
    }
    .btn-follow {
      z-index: 0;
      border: 1px solid #474d52;
      box-sizing: border-box;
      border-radius: 4px;
      width: 54px;
      height: 20px;
      padding: 0px;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 14px;
      transition: 0.2s ease;
      &:hover {
        background-color: #474d52;
        color: #fff;
        &:after,
        &:before {
          content: none;
        }
      }
    }
    .followed {
      width: 65px;
      color: #fff;
      background: #474d52;
    }
  }
}
</style>
